import React from 'react';
import Icon from '../../../components/AppIcon';

const ContentSection = ({ id, title, icon, children, className = "" }) => {
  return (
    <section id={id} className={`scroll-mt-20 ${className}`}>
      <div className="bg-surface rounded-lg border border-border p-6 mb-6">
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
            <Icon name={icon} size={20} color="white" strokeWidth={2} />
          </div>
          <h2 className="text-xl font-semibold text-text-primary">{title}</h2>
        </div>
        {children}
      </div>
    </section>
  );
};

export default ContentSection;